// @flow
import clientsTrainingCertificateViewModal from '../clients/clientsTrainingCertificateViewModal';

export default clientsTrainingCertificateViewModal;
